import api from "../api";

export const useReferal = (data) =>
  api.post("/refer-from", data).then((res) => res.data);
